import React from 'react';
import UI from '../../ui';
import { Options, travelOptions } from '../../components/OptionsSelect';

const { features, travelCompanions, travelStyles } = travelOptions;

const FavouriteFeaturesStep: React.FC = () => {
  return (
    <React.Fragment>
      <UI.VerticalLayout gap={30}>
        <Options
          title="My favorite hotel features"
          subtitle="Select your top 4"
          options={features}
          max={4}
        />
        <Options
          title="I travel with"
          subtitle="Select who you usually travel with"
          options={travelCompanions}
        />
        <Options
          title="My favourite travel styles"
          subtitle="Select the options that best describe your travel preferences"
          options={travelStyles}
        />
      </UI.VerticalLayout>
    </React.Fragment>
  );
};

export default FavouriteFeaturesStep;
